import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCallback, useEffect, useRef,useState } from 'react';

import * as style from './style.module.css';

const ScrollableList = ({ className = '', children, shadow = 'var(--comp-scrollablelist-background-color)', shadowHeight = '40px', arrowSpace = '0px' }) => {
  const scrollRef = useRef(null);
  const [actionsState, setActionState] = useState({ left: true, right: false });

  const handleScroll = useCallback(() => {
    const elem = scrollRef?.current;
    if (elem) {
      setActionState({
        left: elem?.scrollLeft <= 1,
        right: elem?.scrollLeft >= elem?.scrollWidth - elem?.clientWidth - 1,
      });
    }
  }, [children]);

  const handleClickMore = useCallback(() => {
    if (scrollRef?.current) {
      scrollRef.current.scrollLeft += scrollRef?.current?.clientWidth - 60;
    }
  }, []);

  const handleClickLess = useCallback(() => {
    if (scrollRef?.current) {
      scrollRef.current.scrollLeft -= scrollRef?.current?.clientWidth - 60;
    }
  }, []);

  useEffect(() => {
    const elem = scrollRef?.current;
    if (elem) {
      handleScroll();
      elem?.addEventListener('scroll', handleScroll);
      window?.addEventListener('resize', handleScroll);
      return () => {
        elem?.removeEventListener('scroll', handleScroll);
        window?.removeEventListener('resize', handleScroll);
      };
    }
  }, [handleScroll, scrollRef]);

  return (
    <div className={`${style.list} ${className}`} style={{ '--shadow-height': shadowHeight, '--arrow-space': arrowSpace }}>
      <div className={style.scrollable} ref={scrollRef}>
        {children}
      </div>
      <div className={`${style.shadow} ${style.less} ${actionsState.left ? style.hide : ''}`} style={{ background: `linear-gradient(-90deg, rgb(0 0 0 / 0%) 0%, ${shadow} 100%)` }}>
        <FontAwesomeIcon icon={faChevronLeft} onClick={handleClickLess} />
      </div>
      <div className={`${style.shadow} ${style.more} ${actionsState.right ? style.hide : ''}`} style={{ background: `linear-gradient(90deg, rgb(0 0 0 / 0%) 0%, ${shadow} 100%)` }}>
        <FontAwesomeIcon icon={faChevronRight} onClick={handleClickMore} />
      </div>
    </div>
  );
};

export default ScrollableList;
